import * as y from 'yup'

import { EMAIL_DOMAIN_NAME, EMAIL_PATTERN } from '@src/constants/EmailSchema'
import { passwordFieldRules } from '@src/constants/PasswordSchema'

export const schema = y.object({
  firstName: y.string().max(30, 'firstName.invalid').required('firstName.required'),
  lastName: y.string().max(30, 'lastName.invalid').required('lastName.required'),
  email: y
    .string()
    .max(50, 'email.invalid')
    .matches(EMAIL_PATTERN, 'email.invalid')
    .matches(EMAIL_DOMAIN_NAME, 'email.invalid')
    .required('email.required'),
  password: passwordFieldRules.optional().required('password.required'),
})

export type Schema = y.InferType<typeof schema>
